import { createContext } from 'react';
import noop from '../../../utils/noop';

export default createContext({
  isVisible: false,
  refs: {
    setReference: noop,
    setFloating: noop,
  },
  getReferenceProps: (userProps) => ({ ...userProps }),
  floatingStyles: {},
  getFloatingProps: (userProps) => ({ ...userProps }),
  width: undefined,
  zIndex: 999,
  portalRootNode: undefined,
});
